export const patientsPath = '/patients'
